export default "__VITE_ASSET__Dyb0_peJ__"